/**
 * Renderer → main channel for showing a native OS notification.
 * The main-process handler lives in `src/background.ts`.
 */
export const NATIVE_NOTIFICATION_IPC = "native-notification";

/**
 * Route pushed in the main app window when the notification is clicked
 * (forwarded verbatim to the renderer's "navigate" listener).
 */
export type NativeNotificationRoute = {
  name: string;
  params?: Record<string, string>;
  query?: Record<string, string>;
};

export type NativeNotificationPayload = {
  title: string;
  body: string;
  /** Repo-relative icon path, resolved against the app root by the main process. */
  icon?: string | null;
  /** Where a click takes the user; without it a click only focuses the app. */
  route?: NativeNotificationRoute;
};
